import { PseudoElementSelector } from "./pseudo-element.js";
/**
 * {@link https://drafts.csswg.org/css-pseudo-4/#first-line-pseudo}
 */
export class FirstLine extends PseudoElementSelector {
    static of() {
        return new FirstLine();
    }
    constructor() {
        super("first-line");
    }
    *[Symbol.iterator]() {
        yield this;
    }
}
(function (FirstLine) {
    FirstLine.parse = PseudoElementSelector.parseLegacy("first-line", FirstLine.of);
})(FirstLine || (FirstLine = {}));
//# sourceMappingURL=first-line.js.map